import {StandardHeader} from 'ui-library/reactflow/nodes/BenchlingNode/v2/standard/StandardHeader';
import {StandardNode} from 'ui-library/reactflow/nodes/BenchlingNode/v2/standard/StandardNode';
import {StandardSection} from 'ui-library/reactflow/nodes/BenchlingNode/v2/standard/StandardSection';
import {StandardSectionRow} from 'ui-library/reactflow/nodes/BenchlingNode/v2/standard/StandardSectionRow';
import {StandardSections} from 'ui-library/reactflow/nodes/BenchlingNode/v2/standard/StandardSections';

export const StandardBenchlingNode = {
  /**
   * A standard header for a {@link BenchlingNodeV2}. It consumes the context provided by
   * {@link BenchlingNodeV2}, and as such automatically handles node status and disabled status.
   */
  Header: StandardHeader,
  /** A standard flowchart node. */
  Node: StandardNode,
  /**
   * A standard wrapper for sections within a {@link BenchlingNodeV2}. It consumes the context provided by
   * {@link BenchlingNodeV2}, and as such automatically handles section row counts.
   */
  Sections: StandardSections,
  /**
   * A standard section for a {@link BenchlingNodeV2}. It consumes and updates the context provided by
   * {@link BenchlingNodeV2}.
   */
  Section: StandardSection,
  /** A standard section row for a {@link BenchlingNodeV2}. */
  SectionRow: StandardSectionRow,
};
